var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "automation-wizard-overview-description" },
    [
      _c("AutomationPieces", { attrs: { pieces: _vm.template.pieces } }),
      _vm._v(" "),
      _c(
        "h2",
        {
          staticClass:
            "automation-wizard-overview-description__title typographies-heading-h2"
        },
        [_vm._v("\n        " + _vm._s(_vm.template.title) + "\n    ")]
      ),
      _vm._v(" "),
      _c(
        "p",
        {
          staticClass:
            "automation-wizard-overview-description__description typographies-paragraph-medium-regular"
        },
        [_vm._v("\n        " + _vm._s(_vm.template.description) + "\n    ")]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }